import React, { Component } from 'react'
import * as R from 'ramda'
import Colors from 'material-ui/styles/colors'
import TextField from 'material-ui/TextField'
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Divider from 'material-ui/Divider'
import {List, ListItem} from 'material-ui/List'

import StarsRating from 'components/StarsRating'
import Checkbox from 'material-ui/Checkbox'

const categories = [
	"Carpet Installation"
  , "Carpeting"
  , "Chimney Sweeps"
  , "Contractors"
  , "Damage Restoration"
  , "Drywall Installation & Repair"
  , "Electricians"
  , "Fences & Gates"
  , "Fireplace Services"
  , "Flooring"
  , "Garage Door Services"
  , "Gardeners"
  , "Gutter Services"
  , "Handyman"
  , "Heating & Air Conditioning/HVAC"
  , "Home Cleaning"
  , "Home Inspectors"
  , "Keys & Locksmiths"
  , "Landscaping"
  , "Movers"
  , "Painters"
  , "Plumbing"
  , "Pool Cleaners"
  , "Roofing"
  , "Stucco Services"
  , "Tiling"
  , "Tree Services"
  , "Water Heater Installation/Repair"
  , "Window Washing"
]

export default (o) => (
	<div>
		<header
			style={{
				width: "100%"
			  , height: "60px"
			  , top: "0"
			  , zIndex: "5555"
			  , backgroundColor: "#00ACC1"
			  , position: "fixed"
			  , lineHeight: "60px"
			}}
			className="action-bar"
		>
			<div
				style={{
					width: "inherit"
				  , height: "inherit"
				  , textAlign: "center"
				}}
			>
				<span
					style={{
						display: "inline-block"
					  , position: "absolute"
					  , left : "4px"
					}}
					onClick={()=> o.setState("")}
				>
					<svg
						width="16px"
						height="16px"
						viewBox="0 0 17 17"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						style={{
							verticalAlign: "middle"
						  , marginLeft: "12px"
						  , cursor: "pointer"
						  , paddingBottom: "3px"
						  , marginRight: "5px"
						}}
					>
						<title>Group</title>
						<defs></defs>
						<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
							<g id="Group" transform="translate(1.000000, 1.000000)" stroke="#909090" strokeWidth="2">
								<path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
								<path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
							</g>
						</g>
					</svg>
					Main info
				</span>
			</div>
		</header>
		<div style={{
				height: "calc(100vh - 60px)"
			  , overflowY: "scroll"
			  , overflowX: "hidden"
			  , marginTop: "60px"
			  , paddingLeft: "12px"
			  , paddingRight: "16px"
		  }}>
			<div>
				<TextField
					style = {{marginLeft: "5px", marginTop: "0px", marginBottom: ""}}
					fullWidth={true}
					className={(typeof global.md.phone() == 'string')? "company-name" : ""}
					defaultValue = {o.repairman.firstName}
					floatingLabelText = {"Company name"}
					key={`${o.repairman._id}-company`}
					inputStyle={{fontSize: "18"}}
					onBlur={(evt)=>
						(evt.target.value.length)?
							o.docUpd({
								_id: o.repairman._id
							  , firstName: evt.target.value
							  , comments: (!o.repairman.comments)?
									[{
										userID: o.login.userID
									  , auto: true, body: 'Change company name'
									  , date: new Date().valueOf()
									  , value: evt.target.value
									}]
									: [
										...o.repairman.comments
									  , {
											userID: o.login.userID
										  , auto: true, body: 'Change company name'
										  , date: new Date().valueOf()
										  , value: evt.target.value
										}
									]
							})
							: false
					}
				/>
			</div>
			<StarsRating
				style={{marginLeft: "4px"}}
				value = {(o.repairman.rating)? o.repairman.rating:"0"}
				clickable = {true}
				className={(typeof global.md.phone() == 'string')? "company-rating" : ""}
				onChange = {(value) =>
					o.docUpd({
						_id: o.repairman._id
					  , rating: value
					  , comments: (!o.repairman.comments)?
							[{
								userID: o.login.userID
							  , auto: true, body: 'Change rating'
							  , date: new Date().valueOf()
							  , value: value
							}]
							: [
								...o.repairman.comments
							  , {
									userID: o.login.userID
								  , auto: true, body: 'Change rating'
								  , date: new Date().valueOf()
								  , value: value
								}
							]
					})
				}
			/>

				<p
					style={{
						fontSize: "12px"
					  , color: "#909090"
					  , marginLeft: "4px"
					  , paddingTop: "12px"
					}}
				>
					Category
				</p>
				<List style={{marginLeft: "-16px", position: "relative",  paddingTop: "0px", marginTop: "-12px"}}>
					{
						R.map(category => (
							<ListItem style={{height: "45px"}}>
								<table style={{width: "100%"}}><tbody><tr>
								<td style={{height: "45px", width: "45px", verticalAlign: "middle"}}>
									<Checkbox
										checked={~o.repairman.categories.indexOf(category)}
										iconStyle={{
											width: "35px"
										  , height: "35px"
										  , color: "#00d4b3"
										  , fill: "#00d4b3"
										}}
										onCheck={(evt) => {
											(~o.repairman.categories.indexOf(category))?
												o.docUpd({
													_id: o.repairman._id
												  , categories: R.reject(categ => categ == category, o.repairman.categories)
												})
												: o.docUpd({
													_id: o.repairman._id
												  , categories: [...o.repairman.categories, category]
												})
										}}
									/>
								</td>
								<td style={{height: "45px", verticalAlign: "middle"}}><span style={{}}>{category}</span></td>
								<Divider style={{position: "relative", left: "4px", width: "100%"}}/>
								</tr></tbody></table>
							</ListItem>
						), categories)
					}
				</List>
		</div>
	</div>
)



// WEBPACK FOOTER //
// ./src/routes/manager/repairmanForm/GeneralBlock.js